<template>
  <div class="double-image-label u-pad-x-1of12 u-pad-y-xl u-pad-y-md--sm">
    <div class="u-row u-middle u-left u-around">
      <div class="u-w6of12 u-w12of12--sm u-pad-r-md u-pad-r-0--sm u-marg-b-md--sm">
        <app-image :id="data.image1[0].id" :src="data.image1[0].url" :width="800" :height="450" class="u-block u-full-width u-radius u-overflow-hidden" />
        <p class="u-marg-t-sm">
          {{ data.label1 }}
        </p>
      </div>
      <div class="u-w6of12 u-w12of12--sm u-pad-l-md u-pad-l-0--sm u-marg-b-md--sm">
        <app-image :id="data.image2[0].id" :src="data.image2[0].url" :width="800" :height="450" class="u-block u-full-width u-radius u-overflow-hidden" />
        <p class="u-marg-t-sm">
          {{ data.label2 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>